import {SoundDuckConfig} from '@gongxigames/framework/slot/types/SoundDuckConfig';

export type SoundProperties = {
    loop?: boolean;
    panning?: number;
    volume?: number;
    duck?: SoundDuckConfig;
};

export type SoundsProperties = {
    [soundName: string]: SoundProperties;
};
